import React, { Component } from 'react'

import { AgGridReact } from 'ag-grid-react';

import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

import ValueFormatter from '../components/value-formatter'

function CustomPinnedRowRenderer () {}

CustomPinnedRowRenderer.prototype.init = function(params) {
    this.eGui = document.createElement('div')
    this.eGui.style = params.style
    this.eGui.innerHTML = params.value
}

CustomPinnedRowRenderer.prototype.getGui = function() {
    return this.eGui
}

function createTotalPinnedData(gridApi) {

  var result = {
    month:"TOTALS",
    miles : 0,
    amount : 0,
  }
  
  gridApi.forEachNode(row => {
    result.amount += row.data.amount ? parseFloat(row.data.amount) : 0
    result.miles += row.data.miles ? parseFloat(row.data.miles) : 0
  })

  result.amount = result.amount.toFixed(2)
  result.miles = result.miles.toFixed(0)

  return [result]
}

const numberSort = (num1,num2) => {
  return num1 - num2
}

class MieleageGrid extends Component {

  onGridReady = params => {
    params.api.setGridOption('pinnedBottomRowData', createTotalPinnedData(params.api))
  }

  render() {

    return (
      <div className="ag-theme-alpine" style={ {width: '400px'} }>
      <AgGridReact
        rowHeight={44}
        onGridReady={this.onGridReady}
          rowData={this.props.mileage}
          onRowDoubleClicked={item => this.props.actionClickHandler("view",item.data)}
          domLayout='autoHeight'
          columnDefs={[
            {
              field: "month",
              headerName: "Month",
              cellClass : 'textGridCell',
              menuTabs : [],
              sortable: false,
              comparator: numberSort,
              filter: false,
              width : 120,
            },
            {
              field: "miles",
              headerName: "Miles",
              headerClass : "rightAlignHeader",
              cellClass : 'numberGridCell',
              menuTabs : [],
              sortable: false,
              filter: true,
              width : 120,
            },
            {
              field: "amount",
              headerName: "Paid",
              headerClass : "rightAlignHeader",
              cellClass : 'numberGridCell',
              menuTabs : [],
              sortable: false,
              valueFormatter : item => ValueFormatter.formatMoneyOrNull(item.value),
              filter: true,
              width : 120,
            },
          ]}
          components = {{
            customPinnedRowRenderer: CustomPinnedRowRenderer,
          }}
          >
        </AgGridReact>
      </div>
    )
  }
}

export default (MieleageGrid)
